import { CircularProgress } from "@mui/material"
import { useEffect } from "react";

const AppLink = () => {
    // var appLink = "gogas-user://com.extraa.gogas_user/home"; // Deep link to open the app if installed
    var appLink = "gogas-user://"; // Deep link to open the app if installed
    var playStoreLink = "https://play.google.com/store/apps/details?id=com.extraa.gogas_user";

    useEffect(() => {
        window.location = appLink;

        // If the app is not installed, wait for a while and then redirect to Play Store
        setTimeout(function () {
            window.location = playStoreLink;
        }, 1000); // 1 second delay
    })
    return (
        <div
            style={{
                width: "100%",
                height: "90vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // background: "#FFF7DF",
            }}
        >
            <CircularProgress />
        </div>
    )
}

export default AppLink;